import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { OrderService } from '@app/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { VisitasService } from '../../core/service/visitas.service';
import { CrearVisitaComponent } from './crear-visita/crear-visita.component';
import myLocaleEs from '@angular/common/locales/es'
import { registerLocaleData } from '@angular/common';
import Swal from 'sweetalert2';
registerLocaleData(myLocaleEs);

@Component({
  selector: 'app-visitas',
  templateUrl: './visitas.component.html',
  styleUrls: ['./visitas.component.scss']
})
export class VisitasComponent implements OnInit {
 
  modalOptions: NgbModalOptions = {};
  visitas: any;
  id:any;
  events:any;
  constructor(
    private formBuilder: FormBuilder,
    public orderService: OrderService,
    private visitasService: VisitasService,
    private modalService: NgbModal
  ) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    };
  }

  ngOnInit() {



    this.listarVisitas();
  }

  listarVisitas() {
    this.visitasService.visitasCliente().subscribe(data => {
      this.visitas = data.data;
      console.log('visitas', this.visitas);
    });
  }

  createVisita() {
    const modalRef = this.modalService.open(
      CrearVisitaComponent,
      this.modalOptions
    );
    modalRef.componentInstance.title = 'Crear nueva Visita';
    modalRef.result.then(result => {
      if (result) {
        this.listarVisitas();
      }
    });
  }

  crearPDF()
  {
    //console.log(this.Array);

    this.visitasService.verPDF().subscribe(x => {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([x], { type: 'application/pdf' });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
     

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(newBlob);
      var date = new Date();
      const link = document.createElement('a');
      link.href = data;
      link.download = "visita_" + date+ '.pdf';
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );

      setTimeout(function() {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    });


  }
  eliminar(id: string) {
    Swal.fire({
      title: 'Esta seguro de Eliminar la visita?',
      text: 'Una vez eliminado, Ud no podra recuperar la visita eliminado!',
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then(willDelete => {
      if (willDelete.value) {

        this.visitasService.delete(id).subscribe(x => {
          this.listarVisitas();
        });
        Swal.fire('Se elimino correctamente');



      } else {
        Swal.fire('No se pudo eliminar');
      }

      console.log(willDelete);
    });
  }

}

